import React, { Component } from 'react'
import './styles.css'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faFilter, faPen } from '@fortawesome/free-solid-svg-icons'
import { NOME_EMPRESA } from '../../config'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Footer from '../../components/footer'

const estadoInicial = {
    name: '',
    usuarios: [],
    loading: false,
    loadingPesquisa: false,
    redirect: false,
    pesquisa: '',
    tipoPesquisa: 0,
    empresaNome:'',
}

class Usuarios extends Component {

    constructor(props) {
        super(props);
        this.pdfExportComponent = React.createRef(null);
    }
    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
        this.getUsuarios();
    }

    getUsuarios = async () => {
        if (this.props.id === 999999) {
            apiEmployee.get(`/tickets/pegarUsuariosEmpresas/${localStorage.getItem('empresaID')}`)
                .then(res => {
                    this.setState({
                        usuarios: res.data,
                        empresaNome: res.data[0].empresaNome,
                    });
                })
        } else {
        apiEmployee.get(`tickets/pegarusuarios/${localStorage.getItem('empresaID')}`)
            .then(res => this.setState({
                usuarios: res.data
            }))
        }
    }

    deleteUsuario = (id, nome) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <div>
                            <span>Deseja apagar este usuário? ({nome})</span>
                        </div>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    await apiEmployee.delete(`tickets/usuarios/apagar/${id}?empresa=${this.props.id}`).then(
                                        async response => {
                                            if (response.data == true) {
                                                document.location.reload()
                                            }
                                        },
                                        async response => {
                                            this.erroApi(response)
                                        }
                                    )
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    filterItems = (item) => {
        return true
    }



    render() {

        return (
            <div className='page page-list'>
                <div
                    style={{
                        position: "absolute",
                        left: "-900000px",
                        top: 0,
                    }}
                >
                </div>
                {this.state.redirect &&
                    <Redirect to={'/'} />
                }
                {!this.state.loading &&
                    <div>
                        <section>
                            <Header voltar />

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="page-breadcrumb">
                                        <h2 id='titulo'>Usuários</h2>
                                    </div>
                                </div>
                            </div>

                        </section>

                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>

                            <Link to={{
                                pathname: `/addusuario/0`,
                                state: { usuario: undefined }
                            }} className='butaoadicionarcardapio add_button_big'>Criar Usuário</Link>

                            {/* <div className='butaofiltros change_margin_mobile' onClick={(a) => this.setState({ expandido: !this.state.expandido })}> Filtrar  <FontAwesomeIcon icon={faFilter} size="12" color='black' /> </div> */}

                        </div>

                        <div className='add_button_fab'>
                            <Link to={{
                                pathname: `/addusuario/0`,
                                state: { usuario: undefined }
                            }}>
                                +
                            </Link>
                        </div>

                        {/*this.state.expandido &&
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: 10 }}>
                                <div className='col-8' style={{ display: 'flex', flexDirection: 'row' }}>
                                    <div className='col-2'></div>
                                    <div className='filter-field col-8 '>
                                        <span>Status:</span>
                                        <select className='select-filtro' value={this.state.status} onChange={(e) => this.setState({ status: e.currentTarget.value })}>
                                            {this.state.statusOptions.map((opt) => (
                                                <option value={opt.value}>{opt.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className='col-2'></div>
                                </div>
                            </div>
                                            */}

                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div className='col-12 row tickets_div'>
                                {this.state.usuarios.filter(this.filterItems).map((usuario, index) => {

                                    return (
                                        <div className='ticket_wrapper' key={usuario.chave}>
                                            <div className='ticket_header'>
                                                <div className='ticket_titulos' style={{ flexGrow: 2 }}>
                                                    <div className='ticket_titulos_empresa'>{usuario.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')}</div>
                                                    <div className='ticket_titulos_unidade'>{usuario.nome}</div>
                                                </div>
                                                <div className='ticket_titulos' style={{ flexGrow: 1 }}>
                                                    <div className='ticket_titulos_data'></div>
                                                    <div className='ticket_titulos_saldo'>{usuario.telefone.replace(/(\d{2})(\d{2})(\d{4})(\d{5})/, '+$1 ($2) $3-$4')}</div>
                                                </div>
                                            </div>
                                            <hr className='ticket_divider' />
                                            <div className='ticket_footer'>
                                                <div className='ticket_footer_titulo'></div>
                                                <div className='ticket_footer_buttons'>
                                                    <div className='ticket_footer_button'>
                                                        <Link to={{
                                                            pathname: `/addusuario/${usuario.chave}`,
                                                            state: { usuario: { ...usuario } }
                                                        }}>
                                                            <FontAwesomeIcon
                                                                title="Editar"
                                                                icon={faPen}
                                                                color={"#DE3338"}
                                                                size={40} />
                                                        </Link>
                                                    </div>
                                                    <div className='ticket_footer_button'>
                                                        <FontAwesomeIcon
                                                            title="Cancelar"
                                                            icon={faTimes}
                                                            color={"#DE3338"}
                                                            onClick={() => this.deleteUsuario(usuario.chave, usuario.nome)}
                                                            size={40} />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                    </div>
                }
                <Footer selected="USUARIOS" />
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        id: user.id,
        empresa: user.empresa,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(Usuarios)
